import React from 'react';
import styles from './Button.module.scss';
import { Link } from 'react-router-dom';
import { addCustomPathToLink, sanitizeType } from '../../../../functions';

const Button = ({ api, type, animationData }) => {
  return (
    !!api.attributes.btnText &&
    !!api.attributes.btnLink && (
      <Link
        target="_blank"
        data-aos={animationData?.animation}
        data-aos-delay={animationData?.animationDelay}
        data-aos-duration={animationData?.animationDuration}
        data-aos-easing={animationData?.animationEasing}
        data-aos-anchor-placement={animationData?.animationAnchor}
        to={addCustomPathToLink(`${api.attributes.btnLink}`)}
        className={`${styles.btnShowMore} ${sanitizeType(type, styles)}`}
      >
        {api.attributes.btnText}
      </Link>
    )
  );
};
export default Button;
